import React, {useState, useContext} from "react";
import ISO3166 from "iso-3166-1";
import { message, Input, Descriptions, Divider, Select, Space, ConfigProvider } from "antd";
import { Typography } from "antd";
const { Title } = Typography;
import { get_company_by_nit_for_entity } from "../../../services";

import PropTypes from "prop-types";
import { InformationComponent } from "../../InformationComponent";
import { TypeTidCategory } from "../../../constants";
import { isObjectEmpty } from "../../../utils/ObjectOperators";
import { admitedEntities } from "../utils";
import { CircleAnimationCompact } from "../../loading";

const { Search, TextArea } = Input;
const emptyCompanyData = {
	id: "",
	tid: "",
	name: "",	
	country: null,
	address: "",
	type_tid: "",
};

const newForeignCompanyData = {
	name: "",
	tid: "",
	country: null,
	address: "",
	description: "",
	type_tid: "",
};

const optionsTidTypes = [
	{
		value: "company",
		label: "NIT",
	},
	{
		value: "person",
		label: "CUI",
	},
	{
		value: "foreign",
		label: "Extranjero",
	}
];

export const SearchCompanyEntity = ({
	token, 
	entities, 
	loading, 
	onLoading, 
	onValid, 
	onCompanyData,
	entitySelected,
}) => {
	if(!admitedEntities[entitySelected]){
		message.error("Error del Developer: Entidad ingresada en el componente es invalida");
		return <></>;
	}

	const [nit, setNit] = useState("");
	const [typeTid, setTypeTid] = useState("");
	const [companyData, setCompanyData] = useState(emptyCompanyData);
	const [foreignCompanyData, setForeignCompanyData] = useState(null);
	const { theme } = useContext(ConfigProvider.ConfigContext);
	
	const searchNit = async () => {				
		if(typeTid?.trim() === ""){
			message.error("Porfavor selecciona un tipo de nit");
			return;
		}
		
		if(nit?.trim() === ""){
			message.error("Porfavor llena el nit");			
			return;
		}
		
		onLoading(true);
		onValid(false);		
		setCompanyData(emptyCompanyData);
		onCompanyData(null);
		setForeignCompanyData(null);
		
		const response = await get_company_by_nit_for_entity(token, nit, typeTid, false, false);

		if(isObjectEmpty(response) && typeTid === "foreign"){
			changeForeignCompanyData({
				...newForeignCompanyData, 
				tid: nit,
				type_tid: typeTid
			});
			onValid(true);
			onLoading(false);
			return;
		}

		if(isObjectEmpty(response)){
			message.error("No se encontró una compañia con ese nit");
			onLoading(false);
			return;
		}
		
		const sameNit = entities.filter(client => client.entity_company_id === response.id);

		if(sameNit.length > 0){
			message.warning(`Compañia ${admitedEntities[entitySelected].single} "${sameNit[0].name}" esta usando el nit ingresado. Porfavor ingresa otro nit valido`);
			onLoading(false);
			return;
		} 
		
		// Add default address if it doesn't exist
		if (!response.address) {
			response.address = "CIUDAD";
		}
				
		onCompanyData(response);
		setCompanyData(response);
		onValid(true);
		onLoading(false);
	};

	const changeForeignCompanyData = (value) => {
		setForeignCompanyData(value);
		onCompanyData(value);
	};

	const onChangeCountry = (value) => {
		setCompanyData({...companyData, country: value});
		onCompanyData({...companyData, country: value});
	};

	const onChangeAddress = (value) => {
		setCompanyData({...companyData, address: value.target.value});
		onCompanyData({...companyData, address: value.target.value});
	};

	return (
		<>
			<Space.Compact style={{width: "100%"}}>
				<Select
					placeholder="Ingresa el tipo de nit"
					style={{
						width: "25%",
						marginTop: "10px",
						marginBottom: "10px",
					}}
					options={optionsTidTypes}
					value={typeTid}
					onChange={(value) => setTypeTid(value)}
				/>

				<Search
					placeholder="Ingresa Nit"
					style={{
						marginTop: "10px",
						marginBottom: "10px",
					}}
					value={nit}
					onChange={(e) => setNit(e.target.value)}
					onSearch={searchNit}
					enterButton
					loading={loading}
				/>
			</Space.Compact>
			
			{(companyData.id !== "") && 
			<>
				{
					loading &&
					<CircleAnimationCompact/>
				}
				{
					!loading &&
					<>
						<Divider orientation="center">Compañia con el NIT {companyData?.tid}</Divider>
						{/* theme?.components?.Descriptions?.colorTextTertiary  */}
						<Descriptions title="" bordered >
							<Descriptions.Item style={{color: theme?.components?.Descriptions?.colorTextTertiary}} label="Nombre" span={3}>
								{companyData?.name}
							</Descriptions.Item>
							<Descriptions.Item label="País" style={{color: theme?.components?.Descriptions?.colorTextTertiary}} span={1}>
								<Select
									disabled
									placeholder="Selecciona un país"
									value={companyData.country}
									style={{width:"200px"}}
									onChange={onChangeCountry}
									options={
										ISO3166.all().map(country => ({
											value: country.alpha2,
											label: country.country
										}))
									}
								/>
							</Descriptions.Item>
							<Descriptions.Item style={{color: theme?.components?.Descriptions?.colorTextTertiary}} label="Dirección" span={2}>
								<Input 
									value={companyData?.address || ""}
									style={{width:"100%"}}
									onChange={onChangeAddress}
									required
									status={companyData?.address?.trim() === "" ? "error" : ""}
								/>
							</Descriptions.Item>
						</Descriptions>
					</>
				}
			</>
			}

			{foreignCompanyData && 
			<>
				{
					loading &&
					<CircleAnimationCompact/>
				}
				{
					!loading &&
					<>
						<Divider orientation="center">Nueva Compañia Extranjera con el nit {foreignCompanyData?.tid}</Divider>						
						<Title level={4}>Nombre Compañia Extranjera</Title>
						<Input 
							value={foreignCompanyData?.name} 
							onChange={(e) => changeForeignCompanyData({...foreignCompanyData, name: e.target.value})}
							placeholder="Ingresa el nombre..."
						/>						
						<Title level={4}>País</Title>
						<Select
							allowClear
							value={foreignCompanyData.country}
							placeholder="Selecciona un país"
							style={{width:"100%"}}
							onChange={(value) =>
								changeForeignCompanyData({ ...foreignCompanyData, country: value })
							}
							options={
								ISO3166.all().map(country => ({
									value: country.alpha2,
									label: country.country
								}))
							}
						/>						
						<Title level={4}>Dirección</Title>
						<Input 
							value={foreignCompanyData?.address} 
							onChange={(e) => {
								if (e.target.value.trim() === "") {
									message.error("La dirección no puede estar vacía");
									return;
								}
								changeForeignCompanyData({...foreignCompanyData, address: e.target.value});
							}}
							placeholder="Ingresa la dirección..."
							required
							status={foreignCompanyData?.address?.trim() === "" ? "error" : ""}
						/>						
						<Title level={4}>Descripción</Title>
						<TextArea
							value={foreignCompanyData?.description}
							onChange={(e) => changeForeignCompanyData({...foreignCompanyData, description: e.target.value})}
							placeholder="Ingresa una descripcion para la compañia..."
							autoSize={{
								minRows: 3,
								maxRows: 5,
							}}
						/>
						<InformationComponent title={"Tipo de TID"} attribute={TypeTidCategory[foreignCompanyData?.type_tid]}/>
					</>
				}
			</>
			}
		</>
	);
};

SearchCompanyEntity.propTypes = {
	token: PropTypes.string.isRequired,
	entities: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	onLoading: PropTypes.func,
	onValid: PropTypes.func,
	onCompanyData: PropTypes.func,
	entitySelected: PropTypes.string.isRequired,
};